module.exports = __webpack_public_path__ + "img/proses_sto_sc.c0d68f4d.svg";